import React from 'react';

import styles from './styles.module.scss';

const ExampleChartLabel = () => {
	return (
		<div className={styles['root']}>
			<div className={styles['chip']}>Example data</div>
		</div>
	);
};

export default ExampleChartLabel;
